import { numberValidator } from './number/number.validator';
import { arrayContainsValidator } from './array-contains/array-contains.validator';
import { customErrorValidator } from './custom-error/custom-error.validator';
import { conditionalValidator } from './conditional/conditional.validator';
import { atLeastOneItem } from './at-least-one-item.validator';
import { requiredValidator } from './required.validator';
import { customValidator } from './custom.validator';
import { compareToValidator } from './compare-to.validator';
import { dateValidator } from './date/date.validator';
import { claimsFieldValidatorFn } from './claim-field.validator';
import { siteKeyValidatorFn } from './sitekey.validator';
import { dateRangeValidator } from './date/date-range.validator';
import { targetDateRangeValidator } from './date/target-date-range.validator';
import { dateRangeRequiredValidator } from './date/date-range-required.validator';
import { valueRequiredValidator } from 'src/app/shared/validators/value-required.validator';
import { isInstancesNumberTakenAsyncValidator } from './async-validators/async-instance-number.validator';
import { isInvalidPassword } from 'src/app/shared/validators/password.validator';
import { isNotConfirmedPassword } from 'src/app/shared/validators/confirm-password.validator';
import { nullableRequiredValidator } from './nullable-required.validator';
import { dateAfterValidator } from './date/date.after.validator';
import { guidValidator } from './guid.validator';
import { maxLengthHTML } from '@app/shared/validators/max-length-html.validator';
import { noHtmlTagsValidator } from '@app/shared/validators/no-html-tags.validator';
import { noSymbolsValidator } from '@app/shared/validators/no-symbols.validator';
import { cadConnectorIdValidator } from '@app/shared/validators/idnumber.validator';
import { creatorNarrativeValidator } from '@app/shared/validators/creator-narrative.validator';

export class CustomValidators {
  public static numberValidator = numberValidator;
  public static atLeastOneItem = atLeastOneItem;
  public static arrayContainsValidator = arrayContainsValidator;
  public static customErrorValidator = customErrorValidator;
  public static conditionalValidator = conditionalValidator;
  public static requiredValidator = requiredValidator;
  public static nullableRequiredValidator = nullableRequiredValidator;
  public static valueRequiredValidator = valueRequiredValidator;
  public static customValidator = customValidator;
  public static dateValidator = dateValidator;
  public static dateRangeValidator = dateRangeValidator;
  public static dateRangeRequiredValidator = dateRangeRequiredValidator;
  public static targetDateRangeValidator = targetDateRangeValidator;
  public static compareTo = compareToValidator;
  public static claimField = claimsFieldValidatorFn;
  public static isInstancesNumberTakenAsyncValidator = isInstancesNumberTakenAsyncValidator;
  public static isInvalidPassword = isInvalidPassword;
  public static isNotConfirmedPassword = isNotConfirmedPassword;
  public static dateAfter = dateAfterValidator;
  public static guid = guidValidator;
  public static maxLengthHTML = maxLengthHTML;
  public static noHtmlTagsValidator = noHtmlTagsValidator;
  public static siteKeyValidator = siteKeyValidatorFn;
  public static noSymbolsValidator = noSymbolsValidator;
  public static cadConnectorIdValidator = cadConnectorIdValidator;
  public static readonly creatorNarrativeValidator = creatorNarrativeValidator;
}
